// See ./MessageTypes.md for more information about this version number and how
// it's used.

/**
 * The current version of the message protocol.  Should be incremented any time
 * a change is made to any of the types in this 'MessageTypes' folder.
 */
export const messageVersion = 38;

/**
 * The minimum supported version of the message protocol. If one side of the
 * iframe supplies a version less than this, initialization will fail. Should
 * only be updated when non-backwards compatible changes are being made to the
 * types in this 'MessageTypes' folder.
 */
export const minMessageVersion = 0;

/**
 * @param givenMessageVersion version given by the other side of the iframe
 * @returns if the given version is compatible with the known version this side
 * of the iframe
 */
export function isCompatibleMessageVersion(givenMessageVersion: number | undefined = 0): boolean {
  return givenMessageVersion >= minMessageVersion;
}
